import { MapTypeId } from '../_shared/types/googleMaps/googleMaps.types';

export const TESTING_MAP_TYPE = MapTypeId.Coordinate;

export const testingModeEnabled = () => {
  return localStorage.getItem('TESTING_MODE') === 'true';
};
